const meta = {
  '/': {
    title: `XELIS - Private BlockDAG with Smart Contracts`,
    description: `XELIS is the world's first BlockDAG with Privacy, Speed, Scalability and Smart Contracts.`,
    keywords: `BlockDAG, Homomorphic Encryption, Privacy, Confidentiality, Smart Contracts, Rust, Decentralized, Cryptocurrency, Blockchain, XELIS, XEL, Bitcoin, BTC, ETH, Ethereum, Monero, XMR`
  },
  '/resources': {
    title: `XELIS - Resources`,
    description: `Links for wallets, nodes, exhchanges, mining specifications and more.`,
    keywords: `Browser wallet, iOS wallet, Android wallet, Desktop Wallet, XELIS Miner`,
  },
  '/merch': {
    title: `XELIS - Merchandises`,
    description: `Official XELIS premium merchandise products.`,
    keywords: `XELIS hoodies, XELIS t-shirts, XELIS mugs, XELIS accessories`,
  },
  '/exchanges': {
    title: `XELIS - Exchanges`,
    description: `List of exchanges where you can trade XELIS.`,
    keywords: ``
  },
  '/confidentiality': {
    title: `XELIS - Confidentiality`,
    description: ``,
    keywords: ``
  }
}

module.exports = meta;
